<template>
      <div class="black-background">
        <v-dialog overlay-color="#333" :overlay-opacity=".95"  @input="closePost()" v-model="postDialog">
          <div>
            <modal-post style="margin-bottom: 10px;" :mini="this.mini"></modal-post>
          </div>
        </v-dialog>
        <v-row justify="center">
          <v-col  class="column" v-for="(column, index) in columns" :key="index">
            <preview-card @click.native="openPost(12)" class="preview-card-250" v-for="(post, i) in column" :key="i" :postData="post"/>
          </v-col>
        </v-row>
      </div>
</template>

<script>
import PreviewCard from '../components/preview-card.vue';
import ModalPost from '../components/modal-post.vue';

export default {
    name: 'Discover',
    components: {
      PreviewCard,
      ModalPost,
    },
    data: () => ({
      posts: [
        {title: "Elon Musk's OpenAI has released a new transformer based model called GTP-3", imageLinks: ['./test-media/openai.png'], liveCount: Math.round(Math.random() * 1000), tags: ['AI', 'Tech', 'Science']},
        {title: "Earth", imageLinks: ['./test-media/earth.gif'], liveCount: Math.round(Math.random() * 1000), tags: ['Earth']},
        {title: 'Small Image, Very Small Image...', imageLinks: ['./test-media/mini.png'], liveCount: Math.round(Math.random() * 1000), tags: ['Funny']},
        {title: 'Drove my white Model X to the hangar this morning to fly to Africa to shoot drugged out big game animals. Wish me luck, I hope I get a zebra!', imageLinks: ['./test-media/model-x.jpg'], liveCount: Math.round(Math.random() * 1000), tags: ['Tesla', 'Cars', 'Jet']},
        {title: 'Black Magic Magnets', imageLinks: ['./test-media/magic.mov'], liveCount: Math.round(Math.random() * 1000), tags: ['Magic', 'Amazing']},
        {title: 'Movie theater in my basement', imageLinks: ['./test-media/movie-2.jpg'], liveCount: Math.round(Math.random() * 1000), tags: ['Movie', 'Wow']},
        {title: 'Yorkie', imageLinks: ['./test-media/yorkie.jpg'], liveCount: Math.round(Math.random() * 1000), tags: ['Cute', 'Yorkie']},
        {title: 'Translucent head of this snail allows you to see the leaves go through its head as he eats them.', imageLinks: ['./test-media/snail.mov'], liveCount: Math.round(Math.random() * 1000), tags: ['Cute', 'Yorkie']},
        {title: 'New home theater I just finished!', imageLinks: ['./test-media/movie-1.jpg'], liveCount: Math.round(Math.random() * 1000), tags: ['Movie', 'Cozy']},
        {title: 'Hong Kongers were waving US flag during the protest in Hong Kong.', imageLinks: ['./test-media/US.jpeg'], liveCount: Math.round(Math.random() * 1000), tags: ['Hong Kong', 'US']},
        {title: 'Nature...', imageLinks: ['./test-media/desert.jpg'], liveCount: Math.round(Math.random() * 1000), tags: ['Movie', 'Cozy']},
        {title: 'Here, this cuteness is for you!', imageLinks: ['./test-media/deer.mp4'], liveCount: Math.round(Math.random() * 1000), tags: ['Cute', 'Pig']},
        {title: 'Brush time', imageLinks: ['./test-media/dog.mp4'], liveCount: Math.round(Math.random() * 1000), tags: ['Cute', 'Dog']},
        {title: 'We’re more productive than ever, the profits just aren’t trickling down.', imageLinks: ['./test-media/bern.jpg'], liveCount: Math.round(Math.random() * 1000), tags: ['Bern', 'Politics']},
        {title: 'Would you share your snacks with her?', imageLinks: ['./test-media/dog-2.jpg'], liveCount: Math.round(Math.random() * 1000), tags: ['Cute', 'Dog']},
        {title: 'His arms scare me', imageLinks: ['./test-media/spin.mp4'], liveCount: Math.round(Math.random() * 1000), tags: ['Funny']},
        {title: 'Cat loaf', imageLinks: ['./test-media/bread.jpeg'], liveCount: Math.round(Math.random() * 1000), tags: ['Cat', 'Aww']},
        {title: 'How to divide Fractions.', imageLinks: ['./test-media/fract.mp4'], liveCount: Math.round(Math.random() * 1000), tags: []},
        {title: 'An overgrown pool in a abandoned mansion', imageLinks: ['./test-media/green.jpg'], liveCount: Math.round(Math.random() * 1000), tags: []},
      ],
      columns: [],
      postDialog: false,
      openPostID: 0,
      lastReshape: 0,
      mini: false
    }),
    mounted: function () {
      this.reshape();
      this.checkMini();
      window.addEventListener('resize', ()=>{
        if(Date.now() - this.lastReshape < 200) return;
        this.reshape();
        this.checkMini();
      });
      },
    watch: {
      posts: function () {
        console.log('reshaping!!')
      this.reshape();
      }
    },
    methods: {
      openPost: function (postID) {
        this.openPostID = postID;
        this.postDialog = true;
      },
      closePost: function () {
        this.postDialog = false;
        this.openPostID = 0;
      },
      checkMini: function () {
        const width = window.innerWidth;
        if(width <= 350) this.mini = true;
      },
      getColumnCount: function () {
        const width = window.innerWidth;
        return width < 540 ? 1 : (width < 800 ? 2 : (width < 1100 ? 3 : (width < 1350 ? 4 : (width < 1600 ? 5 : 6)) ));
      },
      reshape: function () {
        const columnCount = this.getColumnCount();
        if(columnCount === this.columns.length) return;
        let currentColumn = 0;
        const newColumns = this.posts.reduce((columns, post)=>{
          columns[currentColumn] = columns[currentColumn] ? columns[currentColumn] : [];
          columns[currentColumn].push(post);
          currentColumn === columnCount - 1 ? currentColumn = 0 : currentColumn++
          return columns;
        }, []);
        this.columns = newColumns;
        console.log(`Reshaped to ${this.columns.length} columns`);
      }
    }
  }
</script>

<style scoped>
.container {
  width: 100%;
}

.coltainer {
  margin: 0 auto;
}

.table {
  width: 100%;
}


.row {
  width: 100%;
}

.column {
    max-width: 265px;
}

.preview-card-250 {
  margin: 0 auto;
  padding-top: 4px;
  width: 500px;
}
</style>

<style>
::-webkit-scrollbar {
  width: 0px;
}
</style>





